export default __webpack_public_path__ + "static/media/folder.a22666ae.svg";